import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { Home } from './Home';

/** Luồng N · Trang chủ Ezy (Mint-Home). Route `/ezy/home`; A1 trỏ `/ezy` về đây sau. Không hiện tiền. */
const home: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/home', component: Home })],
};
export default home;
